var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditRecognition.jinja');
require('./MemberProfileEditRecognition.less');

var MemberProfileEditRecognitionItem = require('front/components/MemberProfileEdit/MemberProfileEditRecognitionItem');
var MemberProfileEditRecognitionItemRuntime = require('front/components/MemberProfileEdit/MemberProfileEditRecognitionItemRuntime.jinja');

require('jquery-ui/ui/widgets/sortable');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditRecognition-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditRecognition-buttons-button--save': 'saveEdit',
        'click .MemberProfileEditRecognition-body-form-addInput': 'addRecognition'
    },

    saveApi: function () {
        return Urls['member:api:member'](this.options.memberId, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'updateScroll', 'saveApi');


        window.app.vent.on('MemberProfileEditRecognitionItem-remove', this.updateScroll);

        this.$('.MemberProfileEditRecognitionItem').each(function () {
            new MemberProfileEditRecognitionItem({
                el: this
            });
        });

        if (!app.settings.isPhone) {
            this.recognitionJsp = this.$('.MemberProfileEditRecognition-body-scrollBlock')
                .jScrollPane()
                .bind('mousewheel', function (e) {
                    e.preventDefault();
                })
                .data('jsp');

            this.recognitionSortable = this.$('.MemberProfileEditRecognition-body-form').sortable({
                handle: '.MemberProfileEditRecognitionItem-inputIcons-drag',
                scroll: true
            });

            this.scrollOnDrag = window.app.utils.scrollOnDrag({
                sortInstance: this.recognitionSortable,
                scrollInstance: this.recognitionJsp
            });
        }

        $(window).on('resize', this.updateScroll);
        this.updateScroll();

        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {

        $(window).off('resize', this.updateScroll);

        this.scrollOnDrag && this.scrollOnDrag.destroy();

        window.app.vent.off('MemberProfileEditRecognitionItem-remove', this.updateScroll);

        return Base.prototype.deactivate.call(this, params);
    },


    saveEdit: function () {
        var data = [];
        var order = 0;

        var selector = app.settings.isPhone ? '.MemberProfileEditRecognitionItem-textarea' : '.MemberProfileEditRecognitionItem-input';


        this.$(selector).each(function () {
            var item = {};
            var text = $(this).val();
            var id = $(this).attr('data-id');

            if (text) {
                item.text = text;
                item.order = order++;

                if (id) {
                    item.id = id - 0;
                }

                data.push(item);
            }
        });

        var $button = this.$('.MemberProfileEditRecognition-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'PATCH',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                'recognitions': data
            }),
            success: function (responseData) {

                app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                $button.removeClass('Button--loading');

                //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                //response always contain all profile data up-to-date
                window.app.data.members[this.options.memberId] = responseData;

                window.app.vent.trigger('MemberProfile--updateRecognition', this.options.memberId);

                this.cancelEdit();
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Can\'t update recognitions!');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'recognition');
    },


    addRecognition: function () {
        var $template = $(MemberProfileEditRecognitionItemRuntime.render({data: {}}));

        this.$('.MemberProfileEditRecognition-body-form').append($template);

        new MemberProfileEditRecognitionItem({
            el: $template[0]
        });

        if (!app.settings.isPhone) {
            this.recognitionSortable.sortable('refresh');
            this.updateScroll();
            this.recognitionJsp.scrollToBottom();
        }
    },


    updateScroll: function () {
        if (!app.settings.isPhone) {
            this.recognitionJsp.reinitialise();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditRecognition.js
// module id = 215
// module chunks = 0